import React from "react";
import db from "../../../services/query";
import AriaReport, { buildPrintDocumentTitle, faDigits, printTime, usePrintData } from "./AriaReport";

export default function WeeklyTimetablePrint({ match }) {
  const classId = match.params.classId;
  const { loading, error, data, summary } = usePrintData(
    async () => {
      const { data: body } = await db.getAll(`mis-parity/timetable?classId=${classId}`);
      return body;
    },
    [classId]
  );
  const cls = summary?.cls || {};
  const lectures = Array.isArray(data) ? data : [];
  const weekdays = summary?.weekdays || [];
  const uniqueCredits = {};
  lectures.forEach((row) => {
    const sid = Number(row.subject || row.subject_id);
    if (sid > 0 && uniqueCredits[sid] == null) uniqueCredits[sid] = Number(row.credits || 0);
  });
  const subjectCount = Object.keys(uniqueCredits).length;
  const totalCredits = Object.values(uniqueCredits).reduce((sum, n) => sum + Number(n || 0), 0);
  const byDay = weekdays
    .map((day) => {
      const id = Number(day.id ?? day.weekday_no);
      return {
        id,
        name: day.name || day.weekday_name_fa,
        rows: lectures.filter((row) => Number(row.weekday) === id),
      };
    })
    .filter((day) => day.rows.length);

  if (loading) return <p className="aria-report-status">در حال آماده‌سازی گزارش…</p>;
  if (error) return <p className="aria-report-status" role="alert">{error}</p>;

  return (
    <AriaReport
      className="weekly-timetable-report"
      pageMargin="12mm 10mm"
      documentTitle={buildPrintDocumentTitle([
        "تقسیم اوقات",
        cls.faculty_name,
        cls.class_desc,
        cls.entry_year_fa,
      ])}
      rightLines={["تقسیم اوقات هفته وار", faDigits(cls.entry_year_fa || "")]}
      leftLines={["پوهنتون آریا", "معاونیت علمی", cls.faculty_name]}
    >
      <div className="aria-report-title">
        <h1>{cls.class_desc || ""}</h1>
        {lectures.length ? (
          <p>
            تعداد مضامین: <b>{faDigits(subjectCount)}</b>
            <span> · </span>
            مجموع کریدت: <b>{faDigits(totalCredits)}</b>
          </p>
        ) : null}
      </div>
      {!byDay.length ? (
        <p className="aria-report-empty">برای این صنف تقسیم اوقات ثبت نشده است.</p>
      ) : (
        byDay.map((day) => (
          <section className="weekly-print-day" key={day.id}>
            <h2 className="weekly-day-label">{day.name}</h2>
            <table className="aria-report-table weekly-print-table">
              <colgroup>
                <col className="col-no" />
                <col className="col-teacher" />
                <col className="col-subject" />
                <col className="col-credit" />
                <col className="col-start" />
                <col className="col-end" />
                <col className="col-method" />
              </colgroup>
              <thead>
                <tr>
                  <th>شماره</th>
                  <th>استاد</th>
                  <th>مضمون</th>
                  <th>کریدت</th>
                  <th>ساعت شروع</th>
                  <th>ساعت ختم</th>
                  <th>روش</th>
                </tr>
              </thead>
              <tbody>
                {day.rows.map((row, index) => {
                  const subject = [row.subject_name, row.subject_code].filter(Boolean).join(" - ") || "نامشخص";
                  const practical = Number(row.is_practical) === 1;
                  return (
                    <tr key={row.lecture_id || `${day.id}-${index}`}>
                      <td>{faDigits(index + 1)}</td>
                      <td className="cell-teacher">{row.teacher_name || "نامشخص"}</td>
                      <td className="cell-subject">{subject}</td>
                      <td className="cell-credit">{row.credits == null || row.credits === "" ? "—" : faDigits(row.credits)}</td>
                      <td>{printTime(row.start_time)}</td>
                      <td>{printTime(row.end_time)}</td>
                      <td>
                        <span className={`method-pill${practical ? " is-practical" : ""}`}>
                          {practical ? "عملی" : "نظری"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
        ))
      )}
    </AriaReport>
  );
}
